import { render, staticRenderFns } from "./LoginGeneral.vue?vue&type=template&id=6d4175de&scoped=true&"
import script from "./LoginGeneral.vue?vue&type=script&lang=js&"
export * from "./LoginGeneral.vue?vue&type=script&lang=js&"
import style0 from "./LoginGeneral.vue?vue&type=style&index=0&id=6d4175de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4175de",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFooter } from 'vuetify/lib/components/VFooter';
installComponents(component, {VCol,VFooter})
